import React, { useContext, useState, useMemo } from "react";
import { Button } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { printContext } from "../../../../../../../../core/contexts/printContext";
import { actionColumnFilterOptions } from "../../../../../../../../core/constants/actionColumnFilterOptions";
import CustomTable from "../../../../../../../../layout/components/customTable";
import TagsModal from "../../../../../../../../layout/components/TagsMultiSelect/TagsModal";
import { TrackedItemsVariables } from "../../../../../../../../core/constants/TrackedItemsConstants";
const UserCreatedtrackedItemTable = ({ data, actions, paginationProps = null, currentPage, pageSize, filters, handleCustomTablePropChange = null, isPrintMode = false, paginationSection = null, }) => {
    const { nodeRef } = useContext(printContext);
    const [tagsModalOpen, setTagsModalOpen] = useState(false);
    const [modalTags, setModalTags] = useState([]);
    const [modalSearchValue, setModalSearchValue] = useState("");
    const transformedData = React.useMemo(() => {
        return data === null || data === void 0 ? void 0 : data.map((item) => {
            const tagsArray = item.trackItems || item.tagsDisplay || [];
            const tagsText = tagsArray
                .map((tag) => (tag === null || tag === void 0 ? void 0 : tag.nameLower) || (tag === null || tag === void 0 ? void 0 : tag.name) || "")
                .join(" ")
                .trim();
            return Object.assign(Object.assign({}, item), { tagsSearchable: tagsText, tagsDisplay: tagsArray });
        });
    }, [data]);
    const expandedColumns = [
        {
            fieldName: "name",
            title: ["name"],
            sortable: true,
            className: "bold-text",
            defaultSortOrder: "ascend",
            width: 230,
            render: (text) => React.createElement("span", null, text),
        },
        {
            fieldName: "weightText",
            title: ["TrackedItem.weight"],
            width: 100,
            enableFilter: true,
            render: (_, trackedItem) => {
                let weight = trackedItem.weight;
                let weightText = weight === 0 ? "unrateable" : weight;
                return (React.createElement("div", null,
                    React.createElement("p", null,
                        React.createElement("span", null, weightText))));
            },
        },
        {
            fieldName: "bandColor",
            title: ["TrackedItem.rating"],
            width: 100,
            render: (bandColor, { weight }) => (React.createElement("div", null,
                React.createElement(FontAwesomeIcon, { icon: faCircle, style: {
                        color: weight === TrackedItemsVariables.UnrateableCode
                            ? TrackedItemsVariables.UnrateableColor
                            : bandColor !== null && bandColor !== void 0 ? bandColor : "lightgrey",
                    }, size: "lg" }))),
        },
        {
            fieldName: "benchmarkName",
            title: ["TrackedItem.benchmark", "name"],
            enableFilter: true,
            width: 150,
            render: (benchmarkName) => (React.createElement("div", null,
                React.createElement("p", null,
                    React.createElement("span", null, benchmarkName)))),
        },
        {
            fieldName: "tags",
            title: ["TrackedItem.tags"],
            width: 200,
            render: (_, trackedItem) => {
                const tags = trackedItem.tags || trackedItem.trackItems || [];
                if (!tags || tags.length === 0) {
                    return React.createElement("div", null, "-");
                }
                const visible = tags.slice(0, 3);
                const hasMore = tags.length > 3;
                return (React.createElement("div", { style: {
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "4px",
                        alignItems: "center",
                    } },
                    visible.map((tag) => (React.createElement("span", { key: tag.id || tag.name, style: {
                            background: "#f0f0f0",
                            padding: "2px 8px",
                            borderRadius: "4px",
                            fontSize: "12px",
                        } },
                        React.createElement("span", null, tag.nameLower || tag.name)))),
                    hasMore && (React.createElement(Button, { type: "link", size: "small", onClick: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setModalTags(tags);
                            setTagsModalOpen(true);
                        }, style: { padding: 0 } }, "... more"))));
            },
        },
    ];
    const actionColumn = {
        fieldName: "actions",
        title: ["actions"],
        enableFilter: true,
        filterInfo: {
            //disabled is true in current data source DTO
            listing: actionColumnFilterOptions.map(({ text, value }) => ({
                text,
                value: !value,
            })),
            nestedKey: "disabled",
        },
        render: actions,
        width: 100,
    };
    const expandedDisplayedColumns = actions
        ? [...expandedColumns, actionColumn]
        : expandedColumns;
    // const columns: IColumnType[] = [
    //   {
    //     fieldName: "companyName",
    //     width: 230,
    //     title: ["TrackedItem.site"],
    //     defaultSortOrder: "ascend",
    //     sortable: true,
    //     className: "bold-text",
    //     render: (text) => <CustomTextHighlighter text={text} />,
    //   },
    //   {
    //     fieldName: "darkGreen",
    //     width: 70,
    //     title: ["A"],
    //     align: "center",
    //     render: (darkGreen) => (
    //       <div>
    //         <span className="indicator online darkGreen"></span> &nbsp; &nbsp;{" "}
    //         <span style={{ verticalAlign: "text-bottom" }}>{darkGreen}</span>
    //       </div>
    //     ),
    //   },
    //   {
    //     fieldName: "green",
    //     width: 70,
    //     title: ["B"],
    //     align: "center",
    //     render: (green) => (
    //       <div>
    //         <span className="indicator online green"></span> &nbsp; &nbsp;{" "}
    //         <span style={{ verticalAlign: "text-bottom" }}>{green}</span>
    //       </div>
    //     ),
    //   },
    //   {
    //     fieldName: "amber",
    //     width: 70,
    //     dataIndex: "amber",
    //     title: ["C"],
    //     align: "center",
    //     render: (amber) => (
    //       <div>
    //         <span className="indicator online amber"></span> &nbsp; &nbsp;{" "}
    //         <span style={{ verticalAlign: "text-bottom" }}>{amber}</span>
    //       </div>
    //     ),
    //   },
    //   {
    //     fieldName: "red",
    //     width: 70,
    //     title: ["D"],
    //     align: "center",
    //     render: (red) => (
    //       <>
    //         <div>
    //           <span className="indicator online red"></span> &nbsp; &nbsp;{" "}
    //           <span style={{ verticalAlign: "text-bottom" }}>{red}</span>
    //         </div>
    //       </>
    //     ),
    //   },
    //   {
    //     fieldName: "grey",
    //     width: 70,
    //     title: ["TrackedItem.grey"],
    //     align: "center",
    //     render: (grey) => (
    //       <div>
    //         <span className="indicator online grey"></span> &nbsp; &nbsp;
    //         <span style={{ verticalAlign: "text-bottom" }}>{grey}</span>
    //       </div>
    //     ),
    //   },
    //   {
    //     width: 200,
    //     fieldName: "totalEnabledReports",
    //     title: ["TrackedItem.totalEnabled", "TrackedItem.trackedItems"],
    //     render: (totalEnabledReports) => {
    //       const title = `Total Enabled Tracked Items: ${totalEnabledReports}`;
    //       return (
    //         <Tooltip title={title}>
    //           <div
    //             style={{
    //               whiteSpace: "nowrap",
    //               textAlign: "center",
    //               textOverflow: "ellipsis",
    //               overflow: "hidden",
    //             }}
    //           >
    //             <p>
    //               <CustomTextHighlighter text={title} />
    //             </p>
    //           </div>
    //         </Tooltip>
    //       );
    //     },
    //   },
    // ];
    return (React.createElement("div", { className: "trackedItemListing", "data-test": "tracked-item-listing-table", ref: nodeRef },
        React.createElement(CustomTable, { data: transformedData, columns: expandedDisplayedColumns, dataType: "any", currentPage: currentPage, pageSize: pageSize, totalCount: paginationSection === null || paginationSection === void 0 ? void 0 : paginationSection.totalRecords, itemEnableKey: "disabled", scroll: false, clientPagination: !isPrintMode, customTablePropChange: handleCustomTablePropChange, paginationSection: paginationSection, enableClientSearch: false }),
        React.createElement(TagsModal, { open: tagsModalOpen, onClose: () => {
                setTagsModalOpen(false);
                setModalSearchValue("");
            }, tags: modalTags, searchValue: modalSearchValue, onSearchChange: (val) => setModalSearchValue(val), filteredTags: useMemo(() => {
                if (!modalSearchValue)
                    return modalTags;
                const searchLower = modalSearchValue.toLowerCase();
                return modalTags.filter((tag) => (tag.nameLower || tag.name || "")
                    .toLowerCase()
                    .includes(searchLower));
            }, [modalTags, modalSearchValue]), onRemoveTag: () => { }, isTagCloseable: false })));
};
export default UserCreatedtrackedItemTable;
